/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Control } from 'ol/control';

import { ActiveMapState } from '../state/active-map.state';
import { Select } from '@ngxs/store';
import { CustomGeoPosition } from '../state/active-map.model';
import { Observable } from 'rxjs';
import { distinctUntilChanged, take } from 'rxjs/operators';

export class UserLocationComponent extends Control {

    @Select(ActiveMapState.geolocationEnabled) geolocationEnabled$: Observable<boolean>;
    @Select(ActiveMapState.position) position$: Observable<CustomGeoPosition>;

    readonly element: HTMLDivElement;

    private readonly gotoPositionListener: () => void;

    constructor(
        optOptions: any,
    ) {
        const options = optOptions || {};
        if (!options.callback) {
            throw new Error('Callback is required');
        }
        // super(options);

        const controlElement = document.createElement('div');
        controlElement.classList.add('ol-location');
        controlElement.classList.add('ol-unselectable');
        controlElement.classList.add('ol-control');

        const button: HTMLButtonElement = document.createElement('button');
        button.id = 'button_geolocation';

        button.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83
                         3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77
                         7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>
            </svg>`;
        // button.appendChild(options.svg);

        super({
            ...options,
            ...{element: controlElement, target: options.target},
        });

        this.gotoPositionListener = () => {
            this.position$
                .pipe(take(1))
                .subscribe((position: CustomGeoPosition) => options.callback(position));
        };

        this.element.appendChild(button);

        // Control.call(this, {
        //     element: this.element,
        //     target: options.target,
        // });

        this.geolocationEnabled$.pipe(
            distinctUntilChanged(),
        ).subscribe((enabled) => {
            enabled ? this.enable() : this.disable();
        });
    }

    disable() {
        const button = this.element.firstElementChild as HTMLButtonElement;
        button.disabled = true;
        button.removeEventListener('click', this.gotoPositionListener);
        button.removeEventListener('touchstart', this.gotoPositionListener);
    }

    enable() {
        const button = this.element.firstElementChild as HTMLButtonElement;
        button.disabled = false;
        button.addEventListener('click', this.gotoPositionListener);
        button.addEventListener('touchstart', this.gotoPositionListener);
    }
}
